<template>
    <div class="text-center">
        <v-btn small icon @click="changePoint" v-if="!!showAdminUI">
            <v-icon small :color="item.point <=0 ? `error` : `success`">{{ item.point | changePointIcon }}</v-icon>
        </v-btn>
        <v-icon v-else small :color="item.point <=0 ? `error` : `success`">{{ item.point | changePointIcon }}</v-icon>
    </div>
</template>

<script>
  export default {
    name: 'pointChanger',
    props: ['value', 'mode'],
    data() {
      return {
        item: this.value
      }
    },
    computed: {
      showAdminUI() {
        if (this.mode) {
          return this.mode === 'manager'
        }
        return true
      }
    },
    filters: {
      changePointIcon: function (value) {
        return value <= 0 ? 'mdi-minus-box' : 'mdi-plus-box'
      }
    },
    methods: {
      changePoint() {
        const newpoint = this.item.point > 0  ? 0 : 1

        this.item.point = newpoint

        if(this.item.admin_block_id === 9) {
          this.item.point = newpoint * 2
          this.item.point_to_reports = newpoint * 2
        } else {
          this.item.point = newpoint
          if (this.item.point === 0) {
            if (this.item.last_point > 0) {
              this.item.point_to_reports = newpoint
            }
            if (this.item.last_point <= 0) {
              this.item.point_to_reports = this.item.last_point - 1
            }

            if (this.item.point_to_reports < -1) {
              this.item.point_to_reports = -1
            }
          } else {
            this.item.point_to_reports = newpoint
          }
        }

        this.change()
      },
      change() {
        this.$emit('input', this.item)
        this.$nextTick(function () {
          this.$emit('change')
        })
      }
    }
  }
</script>

<style scoped>

</style>
